import script from "./BrandPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandPreview.vue?vue&type=script&setup=true&lang=js"

import "./BrandPreview.vue?vue&type=style&index=0&id=0b25e5ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b25e5ce"]])

export default __exports__